import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import ContentManagementPage from 'app/pages/ContentManagementPage';
import { selectDealerSelected } from '../../redux/headerSlice/selectors';
import { PageContainer } from '../../sharedComponents/StyledComponents';

/**
 * ContentPage component that reuses ContentManagementPage
 * Adapted for NewAIAvatarLayout theme and selector structure
 */
const ContentPage: React.FC = () => {
  // Get dealer from NewAIAvatarLayout selector
  const selectedDealer = useSelector(selectDealerSelected);

  // Check if dealer is selected
  const isDealerSelected = selectedDealer && 
    selectedDealer !== 'default' && 
    selectedDealer.dealer && 
    selectedDealer.dealer.trim() !== '';

  if (!isDealerSelected) {
    return (
      <PageContainer>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            color: 'text.secondary',
          }}
        >
          Please select a dealer to view content management
        </Box>
      </PageContainer>
    );
  }

  // ContentManagementPage will use its own selector from app/pages/Header/selectors
  // This should work if both selectors point to the same Redux state structure
  // If there are selector conflicts, we may need to create an adapted version
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ContentManagementPage />
    </Box>
  );
};

export default ContentPage;

